/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiNotificationsMutationRequest, PostApiNotificationsMutationResponse, PostApiNotifications400, PostApiNotifications401, PostApiNotifications403, PostApiNotifications500 } from "../../types/PostApiNotifications.ts";
import { postApiNotificationsMutationResponseSchema, postApiNotificationsMutationRequestSchema } from "../../zod/NotificationSchemas/postApiNotificationsSchema.ts";

function getPostApiNotificationsUrl() {
  const res = { method: 'POST', url: `/api/notifications` as const }  
  return res
}

/**
 * @summary Добавление PUSH уведомления
 * {@link /api/notifications}
 */
export async function postApiNotifications({ data }: { data?: PostApiNotificationsMutationRequest }, config: Partial<RequestConfig<PostApiNotificationsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiNotificationsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiNotificationsMutationResponse, ResponseErrorConfig<PostApiNotifications400 | PostApiNotifications401 | PostApiNotifications403 | PostApiNotifications500>, PostApiNotificationsMutationRequest>({ method : "POST", url : getPostApiNotificationsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiNotificationsMutationResponseSchema.parse(res.data)
}